if (!customElements.get("collection-grid")) {
  class CollectionGrid extends HTMLElement {
    constructor() {
      super();
    }

    update(url) {
      fetch(url)
        .then((res) => res.text())
        .then((data) => {
          const html = new DOMParser().parseFromString(data, "text/html");
          if (!html) return;

          const section = html.querySelector(
            `[data-id="${this.dataset.sectionId}"]`
          );
          if (!section) return;

          const grid = section.querySelector("[data-filter-target]");
          if (!grid) return;
          this.innerHTML = grid.innerHTML;

          section.querySelectorAll(".js-filter-accordion").forEach((filter) => {
            const item = this.section.querySelector(
              `[data-filter-label="${filter.dataset.filterLabel}"]`
            );
            filter.classList.toggle(
              "is-open",
              item.classList.contains("is-open")
            );
          });

          const filters = section.querySelector(".js-filters");

          if (!filters || !this.filters) return;
          this.filters.innerHTML = filters.innerHTML;
          window.history.pushState({}, "", url);

          this.filters
            .querySelectorAll(".js-filter-accordion")
            .forEach((acc) => {
              acc.updateHeight();
            });
        })
        .catch((err) => console.error(err));
    }

    updateFilter(settings) {
      let url;

      switch (settings.type) {
        case "list":
          url = new URL(window.location.origin + settings.url);
          break;
        case "price":
          url = new URL(window.location.href);
          url.searchParams.set("filter.v.price.lte", settings.unencoded[1]);
          url.searchParams.set("filter.v.price.gte", settings.unencoded[0]);
        default:
          break;
      }

      this.update(url);
    }

    connectedCallback() {
      this.section = this.closest(".shopify-section");
      this.filters = this.section.querySelector(".js-filters");
    }
  }
  customElements.define("collection-grid", CollectionGrid);
}
